module.exports = __webpack_public_path__ + "img/Calendar.e4e89844.svg";